import * as React from "react"
import 'intersection-observer';
import { InView } from 'react-intersection-observer';
import { Action, IOWidget, mk_widget, Pair } from "widgets-for-react"
import { Id, CMSState, ImageSize, Url } from "../../../../cms/blocks/types.gen";
import { link, getClassName, linkWrapper } from "../../../../cms/blocks/utils.gen"
import { ImageContainer } from "../../../../cms/blocks/widgets/ImageContainer.gen";
import { blockInviewHandler } from "../../../utils/inview_utils";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { WordPress } from "../../../../wordpress/wordpress_api";
import { decodeHTMLEntities, gtmPush, toRelativeUrl } from "../../../../../helpers";
import { ButtonData } from "../../../../wordpress/types_and_parser/extra_types.mod";
import { getImageAttribute } from "../../../utils/extra_images.mod";

export type CtaAttributes = {
    blockName: 'vidda/cta'
    title: string
    intro: string
    image?: WordPress.MediaResponse
    image_position?: 'left' | 'right'
    primary_button?: ButtonData
    secondary_button?: ButtonData
}

export interface CtaInterface {
    blockName: 'vidda/cta'
    attrs: CtaAttributes
}

export type CtaBlockProps<extra_images> = CtaAttributes

export type CtaBlockStyle = Partial<{
  block_contentwidth_classname: string
  block_fullwidth_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  visual_classname: string
  image_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function CtaBlock<customBlockData, extra_images>(
  props: CtaBlockProps<extra_images>,
  options?: { style?: CtaBlockStyle; key?: string }
): IOWidget<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<customBlockData, extra_images, never>>> {
  return (cmsState: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: _ => {
      const hasImage = props.image && props.image.media_details;
      return ( <section className={`block block--cta cta--${hasImage ? 'image' + (props.image_position === 'right' ? ' cta--image-right' : ' cta--image-left' ) : 'text'}`}>
          <div className={`block__inner container border-radius--s`}>
            <div className={`block__content${hasImage ? ' ls-first-item' : ''}`}>
              {props.title && <h2 className={`block__title typo--l ff--primary${hasImage ? '' : ' ls-second-item'}`}>{decodeHTMLEntities(props.title)}</h2>}
              {props.intro && <div className={`block__intro text--styled${hasImage ? '' : ' ls-first-item'}`} dangerouslySetInnerHTML={{ __html: props.intro }}></div>}
              {(props.primary_button || props.secondary_button) && (<footer className={`block__footer${hasImage ? '' : ' ls-third-item'}`}>
                <div className="ls-clickables">
                  {props.primary_button && (
                  <>
                    {link(linkWrapper({title:props.primary_button.text,url:props.primary_button.url}),
                      { classname: 'button button--tertiary ls-clickable' },
                      props.primary_button.text, 
                      () => {
                        gtmPush({
                          event: props.image ? "call_to_action_with_image" : "call_to_action", 
                          cta_type: "primary_button", 
                          click_text: props.primary_button.text
                        })
                      }
                      )}
                  </>
                  )}
                  {props.secondary_button && (
                  <>
                    {link(linkWrapper({title:props.secondary_button.text,url:props.secondary_button.url}),
                      { classname: 'button button--tertiary ls-clickable' },
                      props.secondary_button.text,
                      () => {
                        gtmPush({
                          event: props.image ? "call_to_action_with_image" : "call_to_action", 
                          cta_type: "secondary_button", 
                          click_text: props.secondary_button.text
                        })
                      }
                    )}
                  </>
                  )}
                </div>
            </footer>)}
          </div>
          {hasImage && (
            <div className="block__visual ls-second-item">
              <img
                src='/frontend/images/empty.png'
                width={getImageAttribute(props.image, 'shared-s', 'width')}
                height={getImageAttribute(props.image, 'shared-s', 'height')}
                className="block__image border-radius--s lazyload"
                alt={props.image.alt_text ? props.image.alt_text : ''}
                data-sizes="auto"
                data-src={getImageAttribute(props.image, 'shared-s', 'source_url')}
                data-srcset={`${getImageAttribute(props.image, 'shared-s', 'source_url')} 440w,
                ${getImageAttribute(props.image, 'shared-m', 'source_url')} 880w,
                ${getImageAttribute(props.image, 'shared-l', 'source_url')} 1540w`}
              />
            </div>
          )}
          </div>
        </section>
      );
  }})
}
